import { useState } from "react";
import useClientes from "./hooks/useClientes";
import useTarifas from "./hooks/useTarifas";
import useTarifasClientes from "./hooks/useTarifasClientes";
import TabClientes from "./components/TabClientes";
import TabTarifas from "./components/TabTarifas";
import TabTarifasClientes from "./components/TabTarifaClientes";
import ClientesFormModal from "./components/ClientesFormModal";
import TarifasFormModal from "./components/TarifasFormModal";
import TarifasClientesFormModal from "./components/TarifasClientesFormModal";
import { IconWorldDollar, IconCurrencyDollar, IconBuilding } from "@tabler/icons-react";

const AdminClientesPage = () => {
  const {
    tarifasClientes,
    loading: loadingTarifasClientes,
    error: errorTarifasClientes,
    busqueda: busquedaTarifasClientes,
    setBusqueda: setBusquedaTarifasClientes,
    filtrarTarifasClientes,
    fetchTarifasClientes,
  } = useTarifasClientes();

  const { tarifas, loading: loadingTarifas, error: errorTarifas, busqueda: busquedaTarifas, setBusqueda: setBusquedaTarifas, filtrarTarifas, fetchTarifas } = useTarifas();

  const { busqueda, setBusqueda, loading, error, filtrarClientes, fetchClientes } = useClientes();

  const [tabActiva, setTabActiva] = useState("TarifasCliente");

  // Clientes
  const [modalVisible, setModalVisible] = useState(false);
  const [clienteParaEditar, setClienteParaEditar] = useState(null);

  // Tarifas
  const [modalTarifaVisible, setModalTarifaVisible] = useState(false);
  const [tarifaParaEditar, setTarifaParaEditar] = useState(null);

  // TarifasClientes
  const [modalTarifaClientesVisible, setModalTarifaClientesVisible] = useState(false);
  const [tarifaClientesParaEditar, setTarifaClientesParaEditar] = useState(null);

  // Clientes
  const abrirModal = () => {
    setClienteParaEditar(null);
    setModalVisible(true);
  };

  const cerrarModal = () => {
    setModalVisible(false);
    setClienteParaEditar(null);
  };

  const handleSuccessInsert = () => {
    cerrarModal();
    fetchClientes();
  };

  const handleEditarCliente = (cliente) => {
    setClienteParaEditar(cliente);
    setModalVisible(true);
  };

  // Tarifas
  const abrirModalTarifa = () => {
    setTarifaParaEditar(null);
    setModalTarifaVisible(true);
  };

  const cerrarModalTarifa = () => {
    setModalTarifaVisible(false);
    setTarifaParaEditar(null);
  };

  const handleEditarTarifa = (tarifa) => {
    setTarifaParaEditar(tarifa);
    setModalTarifaVisible(true);
  };

  const handleSuccessInsertTarifa = () => {
    cerrarModalTarifa();
    fetchTarifas();
  };

  // Tarifas Clientes
  const abrirModalTarifaClientes = () => {
    setTarifaClientesParaEditar(null);
    setModalTarifaClientesVisible(true);
  };

  const cerrarModalTarifaClientes = () => {
    setModalTarifaClientesVisible(false);
    setTarifaClientesParaEditar(null);
  };

  const handleEditarTarifaClientes = (tarifaClientes) => {
    setTarifaClientesParaEditar(tarifaClientes);
    setModalTarifaClientesVisible(true);
  };

  const handleSuccessInsertTarifaClientes = () => {
    cerrarModalTarifaClientes();
    fetchTarifasClientes();
  };

  if (loading || loadingTarifas || loadingTarifasClientes) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <h1>
          Cargando...
          <p>
            <svg id="page-preload" viewBox="25 25 50 50">
              <circle r="20" cy="50" cx="50"></circle>
            </svg>
          </p>
        </h1>
      </div>
    );
  }

  if (error || errorTarifas || errorTarifasClientes) {
    return (
      <div className="alert alert-danger text-center" role="alert">
        {error || errorTarifas}
      </div>
    );
  }

  return (
    <div className="page-body">
      <div className="container-xl">
        <div className="card mt-5">
          <div className="card-header">
            <ul className="nav nav-tabs card-header-tabs nav-fill" data-bs-toggle="tabs">
              <li className="nav-item">
                <a href="#tabs-TarifasCliente" className={`nav-link ${tabActiva === "TarifasCliente" ? "active" : ""}`} onClick={() => setTabActiva("TarifasCliente")}>
                  <IconWorldDollar className="icon me-2" />
                  Tarifas por clientes
                </a>
              </li>
              <li className="nav-item">
                <a href="#tabs-Tarifas" className={`nav-link ${tabActiva === "Tarifas" ? "active" : ""}`} onClick={() => setTabActiva("Tarifas")}>
                  <IconCurrencyDollar className="icon me-2" />
                  Tarifas
                </a>
              </li>
              <li className="nav-item">
                <a href="#tabs-Clientes" className={`nav-link ${tabActiva === "Clientes" ? "active" : ""}`} onClick={() => setTabActiva("Clientes")}>
                  <IconBuilding className="icon me-2" />
                  Clientes
                </a>
              </li>
            </ul>
          </div>
          <div className="card-body">
            <div className="tab-content">
              {/* TAB CONTENIDO TARIFAS */}
              <div className={`tab-pane ${tabActiva === "Tarifas" ? "active show" : ""}`} id="tabs-Tarifas">
                <TabTarifas tarifas={filtrarTarifas()} onEditar={handleEditarTarifa} busqueda={busquedaTarifas} setBusqueda={setBusquedaTarifas} abrirModal={abrirModalTarifa} />
                <TarifasFormModal visible={modalTarifaVisible} onClose={cerrarModalTarifa} onSuccess={handleSuccessInsertTarifa} tarifaParaEditar={tarifaParaEditar} />
              </div>
              {/* TAB CONTENIDO CLIENTES */}
              <div className={`tab-pane ${tabActiva === "Clientes" ? "active show" : ""}`} id="tabs-Clientes">
                <TabClientes
                  clientes={filtrarClientes()}
                  onEditar={handleEditarCliente}
                  onEliminar={(cliente) => console.log("Eliminar:", cliente)}
                  busqueda={busqueda}
                  setBusqueda={setBusqueda}
                  abrirModal={abrirModal}
                />
                <ClientesFormModal visible={modalVisible} onClose={cerrarModal} onSuccess={handleSuccessInsert} clienteParaEditar={clienteParaEditar} />
              </div>
              {/* TAB CONTENIDO UNION TARIFA Y CLIENTES */}
              <div className={`tab-pane ${tabActiva === "TarifasCliente" ? "active show" : ""}`} id="tabs-TarifasCliente">
                <TabTarifasClientes
                  tarifasClientes={filtrarTarifasClientes()}
                  onEditar={handleEditarTarifaClientes}
                  busqueda={busquedaTarifasClientes}
                  setBusqueda={setBusquedaTarifasClientes}
                  abrirModal={abrirModalTarifaClientes}
                />
                <TarifasClientesFormModal
                  visible={modalTarifaClientesVisible}
                  onClose={cerrarModalTarifaClientes}
                  onSuccess={handleSuccessInsertTarifaClientes}
                  tarifaClientesParaEditar={tarifaClientesParaEditar}
                  listaClientes={filtrarClientes()}
                  listaTarifas={filtrarTarifas()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminClientesPage;
